/**
 * Fetch a fresh reCAPTCHA v3 token for a form submission.
 *
 * The statamic-recaptcha script attaches a token once on page load, but v3
 * tokens expire after two minutes and are single-use. Anyone who takes longer
 * than that to fill in a form (or submits a second time) would be rejected as
 * a robot, so we request a new token right before every submit.
 *
 * @returns {Promise<{captcha_token: string, captcha_action: string}|null>}
 */
function getRecaptchaFields() {
    const config = window.recaptchaV3;

    if (! config?.siteKey || typeof window.grecaptcha?.execute !== 'function') {
        return Promise.resolve(null);
    }

    // Must match the action the vendor script uses, as the server compares them.
    const action = 'formsubmission/' + config.action;

    return new Promise((resolve) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(config.siteKey, {action})
                .then((token) => resolve({captcha_token: token, captcha_action: action}))
                .catch(() => resolve(null));
        });
    });
}

export {
    getRecaptchaFields,
}
